import { IContainer, injectContainer } from '../../interface/container';

export interface ICallbackController<CallbackMap> {
    subscribe: <Event extends keyof CallbackMap, Callback extends CallbackMap[Event]>(
        callback: Callback,
        event: Event,
        key?: string,
    ) => void;
    unsubscribe: <Event extends keyof CallbackMap, Callback extends CallbackMap[Event]>(
        callback: Callback,
        event: Event,
    ) => void;
    search: <Event extends keyof CallbackMap, Callback extends CallbackMap[Event]>(
        subscriberKey: string,
        event: Event,
    ) => Array<Callback> | undefined;
    eventListeners: <Event extends keyof CallbackMap, Callback extends CallbackMap[Event]>(
        event: Event,
    ) => Array<Callback>;
}

export interface ICallbackBuilder {
    build: <Callback>() => ICallbackController<Callback>;
}

const TYPES = {
    ICallbackBuilder: Symbol.for('ICallbackBuilder'),
};

export function injectCallbackBuilder(container: IContainer = injectContainer()): ICallbackBuilder {
    return container.get<ICallbackBuilder>(TYPES.ICallbackBuilder);
}

export function bindCallbackBuilder(
    val: ICallbackBuilder,
    container: IContainer = injectContainer(),
) {
    return container.bind<ICallbackBuilder>(TYPES.ICallbackBuilder, val);
}

export function unbindCallbackBuilder(container: IContainer = injectContainer()) {
    return container.remove(TYPES.ICallbackBuilder);
}
